import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities } from '@redux/entities'

import api from '@functions/api'

import type { AssetTypeModel } from '@models/types'

import type { AppDispatch } from '@redux/store'
import type { Action, Errors } from '@redux/modules/types'

import { handleError } from '../utils'

const FETCH_REQUEST = 'realbase/assetType/FETCH_REQUEST'
const FETCH_SUCCESS = 'realbase/assetType/FETCH_SUCCESS'
const FETCH_FAILURE = 'realbase/assetType/FETCH_FAILURE'

export type AssetTypeModuleState = {
  errors: string[],
  loaded: boolean,
  loading: boolean,
}

// Initial State
const initialState: AssetTypeModuleState = {
  errors: [],
  loaded: false,
  loading: false,
}

// Actions
export function fetchRequest() {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess() {
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors: Errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Action Creators
export function loadAssetTypes() {
  return (dispatch: AppDispatch) => {
    dispatch(fetchRequest())

    const promise = api('/references/asset-types')
      .then(({ data }: { data: AssetTypeModel[] }) => {
        const normalizedJson = normalize(data, Schemas.ASSET_TYPE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true as const, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false as const, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(
  state: AssetTypeModuleState = initialState,
  action: Action = { type: '' },
): AssetTypeModuleState {
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors || [],
      }
    default:
      return state
  }
}
